





















































































































































import { Component, Vue } from "vue-property-decorator";
import { storeScEmergency } from "@/store/modules/ScEmergencyStore";
import ScEmergencySvc from "@/services/ScEmergencyService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import moment from "moment";
import ScEmergencyForm from "./ScEmergencyForm.vue";

@Component({
  components: { ScEmergencyForm }
})
export default class ScEmergencyList extends Vue {
  storeModule = storeScEmergency;
  showDetail = false;
  editData: any = null;

  filterTglDari = "";
  filterTglSampai = "";
  filterHasil: any = null;
  filterKategori: any = null;
  filterShift: any = null;
  filterSearch = "";

  hasilOptions = [
    { text: "Tercapai", value: "tercapai" },
    { text: "Tidak Tercapai", value: "tidak_tercapai" },
    { text: "Tidak Dihitung", value: "tidak_dihitung" },
  ];

  kategoriOptions = [
    { text: "Kategori I", value: "i" },
    { text: "Kategori II", value: "ii" },
    { text: "Kategori III", value: "iii" },
  ];

  shiftOptions = [
    { text: "Pagi", value: "pagi" },
    { text: "Siang", value: "siang" },
    { text: "Malam", value: "malam" },
  ];

  headers = [
    { text: "No. Event", value: "nomor_event", width: "155px" },
    { text: "Tgl. Operasi / Shift", value: "tanggal_operasi", width: "130px" },
    { text: "Pasien", value: "pasien" },
    { text: "Operator / Kategori", value: "operator" },
    { text: "Waktu T0/T1", value: "waktu", width: "130px" },
    { text: "Selisih", value: "selisih_menit", width: "90px" },
    { text: "Hasil", value: "hasil", width: "120px" },
    { text: "Status", value: "status", width: "130px" },
    { text: "Aksi", value: "actions", sortable: false, width: "110px" },
  ];

  // Timer hidup — elapsed "berjalan" untuk event yang T1-nya belum diisi
  now = Date.now();
  private elapsedTimer: number | null = null;

  mounted() {
    this.loadData();
    this.elapsedTimer = window.setInterval(() => {
      this.now = Date.now();
    }, 30000);
  }

  beforeDestroy() {
    if (this.elapsedTimer) {
      clearInterval(this.elapsedTimer);
    }
  }

  elapsedMinutes(item: any): number {
    // referensi this.now membuat computed re-render tiap tick
    return Math.max(0, moment(this.now).diff(moment(item.t0_keputusan), "minutes"));
  }

  async loadData() {
    const params: any = {};
    if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
    if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
    if (this.filterHasil) params.hasil = this.filterHasil;
    if (this.filterKategori) params.kategori_seksio = this.filterKategori;
    if (this.filterShift) params.shift = this.filterShift;
    if (this.filterSearch) params.search = this.filterSearch;
    await this.storeModule.loadEvents(params);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  formatTime(d: string) {
    return d ? moment(d).format("HH:mm") : "-";
  }

  formatShift(s: string) {
    const map: any = { pagi: "Pagi", siang: "Siang", malam: "Malam" };
    return map[s] || "-";
  }

  kategoriLabel(k: string) {
    return k ? "Kategori " + k.toUpperCase() : "-";
  }

  selisihColor(item: any) {
    if (item.hasil === "tercapai") return "green--text";
    if (item.hasil === "tidak_tercapai") return "red--text";
    return "grey--text";
  }

  tambahBaru() {
    this.editData = null;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.showDetail = true;
  }

  bisaHapus(item: any): boolean {
    if (!item.is_locked) return true;
    const slots = [
      { ditandatangani: item.signed_petugas_at, penandaTanganId: item.petugas_pengisi_id },
      { ditandatangani: item.signed_ka_ibs_at, penandaTanganId: item.ka_ibs_user_id },
      { ditandatangani: item.signed_komite_mutu_at, penandaTanganId: item.komite_mutu_user_id }
    ];
    if (!slots.some(slot => !!slot.ditandatangani)) return false;
    return !alasanTtdMengunciHapus(item.creator_user_id, slots, userModule.user?.id);
  }

  async hapus(item: any) {
    if (!this.bisaHapus(item)) return;
    if (!confirm("Hapus event SC Emergensi ini?")) return;
    try {
      const resp = await ScEmergencySvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus event");
        this.loadData();
      }
    } catch {
      // handled by ErrorAlert
    }
  }

  printPdf(id: number) {
    ScEmergencySvc.printPdf(id);
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }
}
